module.exports = __webpack_public_path__ + "static/media/loading5.bb61c237.gif";